import type { ReactNode } from "react";

import { cn } from "../../lib/utils";
import { useSimpleChatMessageDirection } from "./useSimpleChatMessageDirection";

export interface SimpleChatMessageFooterProps {
  className?: string;
  /** Whatever belongs under the bubble -- `AIFeedbackButtons`, a timestamp, a retry action. */
  children?: ReactNode;
}

/**
 * The row beneath a `SimpleChatMessage`'s bubbles. It has no opinion on its contents; it only keeps
 * them on the same edge as the bubble, which it reads from the message's `direction`.
 */
export const SimpleChatMessageFooter = ({ className, children }: SimpleChatMessageFooterProps) => {
  const direction = useSimpleChatMessageDirection();

  return (
    <div
      data-slot="simple-chat-message-footer"
      className={cn("flex items-center gap-1", direction === "outbound" ? "justify-end" : "justify-start", className)}
    >
      {children}
    </div>
  );
};
